import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const brl = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const dataBR = (d) => { if (!d) return "-"; const [y, m, day] = d.split("-"); return `${day}/${m}/${y}`; };
const MESES = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
const AZUL = [37, 99, 235];

function header(doc, empresa, titulo) {
  doc.setFillColor(...AZUL);
  doc.rect(0, 0, 210, 26, "F");
  let tx = 14;
  if (empresa?.logo) { try { doc.addImage(empresa.logo, "PNG", 12, 4, 18, 18); tx = 34; } catch (e) { /* ignore */ } }
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(15); doc.setFont("helvetica", "bold");
  doc.text(empresa?.nome || "Casa de Repouso São Jorge", tx, 12);
  doc.setFontSize(8.5); doc.setFont("helvetica", "normal");
  doc.text(`CNPJ: ${empresa?.cnpj || "-"}${empresa?.telefone ? "  ·  " + empresa.telefone : ""}`, tx, 18);
  doc.setFontSize(12); doc.setFont("helvetica", "bold");
  doc.text(titulo, 196, 14, { align: "right" });
  doc.setTextColor(30, 41, 59);
}

export function gerarContasPagarPDF({ empresa, contas, fornById = {} }) {
  const doc = new jsPDF();
  header(doc, empresa, "CONTAS A PAGAR");
  const rows = (contas || []).map((c) => [
    c.descricao, fornById[c.fornecedorId]?.nome || "-", c.categoria || "-",
    dataBR(c.vencimento), c.status === "pago" ? "Pago" : "Pendente", brl(c.valor),
  ]);
  const total = (contas || []).reduce((s, c) => s + (Number(c.valor) || 0), 0);
  const pago = (contas || []).filter((c) => c.status === "pago").reduce((s, c) => s + (Number(c.valor) || 0), 0);
  autoTable(doc, {
    startY: 32, head: [["Descrição", "Fornecedor", "Categoria", "Vencimento", "Status", "Valor"]],
    body: rows, styles: { fontSize: 8.5 }, headStyles: { fillColor: AZUL },
    columnStyles: { 5: { halign: "right" } },
    foot: [["", "", "", "", "Total", brl(total)], ["", "", "", "", "Pago", brl(pago)], ["", "", "", "", "Em aberto", brl(total - pago)]],
    footStyles: { fillColor: [241, 245, 249], textColor: [30, 41, 59], fontStyle: "bold", halign: "right" },
  });
  doc.save(`contas-a-pagar-${new Date().toISOString().slice(0, 10)}.pdf`);
}

export function gerarContasReceberPDF({ empresa, faturas, resById = {} }) {
  const doc = new jsPDF();
  header(doc, empresa, "CONTAS A RECEBER");
  const rows = (faturas || []).map((f) => [
    resById[f.residenteId]?.nome || "-",
    `${MESES[Number(f.mes.split("-")[1]) - 1]}/${f.mes.split("-")[0]}`,
    dataBR(f.vencimento), f.paga ? "Paga" : "Em aberto", brl(f.total),
  ]);
  const total = (faturas || []).reduce((s, f) => s + (Number(f.total) || 0), 0);
  const recebido = (faturas || []).filter((f) => f.paga).reduce((s, f) => s + (Number(f.total) || 0), 0);
  autoTable(doc, {
    startY: 32, head: [["Residente", "Ref.", "Vencimento", "Status", "Valor"]],
    body: rows, styles: { fontSize: 8.5 }, headStyles: { fillColor: AZUL },
    columnStyles: { 4: { halign: "right" } },
    foot: [["", "", "", "Total", brl(total)], ["", "", "", "Recebido", brl(recebido)], ["", "", "", "Em aberto", brl(total - recebido)]],
    footStyles: { fillColor: [241, 245, 249], textColor: [30, 41, 59], fontStyle: "bold", halign: "right" },
  });
  doc.save(`contas-a-receber-${new Date().toISOString().slice(0, 10)}.pdf`);
}

// DRE regime de caixa: receitas (faturas pagas) - despesas (contas pagas), mês a mês do ano.
export function gerarDrePDF({ empresa, ano, meses, despesasPorCategoria, totais }) {
  const doc = new jsPDF();
  header(doc, empresa, `DRE ${ano}`);
  doc.setFontSize(9); doc.setFont("helvetica", "normal");
  doc.text("Demonstração do Resultado (regime de caixa) — valores efetivamente recebidos e pagos.", 14, 32);

  const rows = meses.map((m) => [
    m.label, brl(m.receitas), brl(m.despesas),
    { content: brl(m.resultado), styles: { textColor: m.resultado >= 0 ? [16, 122, 87] : [220, 38, 38] } },
  ]);
  autoTable(doc, {
    startY: 37, head: [["Mês", "Receitas", "Despesas", "Resultado"]],
    body: rows, styles: { fontSize: 9 }, headStyles: { fillColor: AZUL },
    columnStyles: { 1: { halign: "right" }, 2: { halign: "right" }, 3: { halign: "right" } },
    foot: [[
      "TOTAL DO ANO", brl(totais.receitas), brl(totais.despesas),
      { content: brl(totais.resultado), styles: { textColor: totais.resultado >= 0 ? [16, 122, 87] : [220, 38, 38] } },
    ]],
    footStyles: { fillColor: [241, 245, 249], textColor: [30, 41, 59], fontStyle: "bold", halign: "right" },
  });

  const cats = Object.entries(despesasPorCategoria || {}).sort((a, b) => b[1] - a[1]);
  if (cats.length) {
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 8,
      head: [["Despesas por categoria (ano)", "Valor"]],
      body: cats.map(([nome, v]) => [nome, brl(v)]),
      styles: { fontSize: 9 }, headStyles: { fillColor: [100, 116, 139] },
      columnStyles: { 1: { halign: "right" } },
    });
  }
  doc.save(`dre-${ano}.pdf`);
}
